<template>
  <div :class="change_color?'leftbar2':'leftbar'">
    <ul>
      <li class="left_bar_block" v-for="(v,k) in list" :key="k">
        <div class="item" @click="goUrl(v)">
          <a href="javascript:void(0)">{{ v.advName }}</a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getadvList } from '@/api/home'
export default {
  props: {
    change_color: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    ...mapGetters(['isLogin', 'cartNum', 'config'])
  },
  methods: {
    getList() {
      // 导航分类
      getadvList({
        platform: 1,
        AdvPosition: 2
      }).then(({ data }) => {
        this.list = data
      })
    },
    goUrl(e) {
      switch (parseInt(e.typekey)) {
        case 1: // 商品详情
          this.$router.push(`/goods/info/${e.typevalue}`)
          break
        case 2: // 文章单页
          this.$router.push(`/parse?key=${e.typevalue}`)
          break
        case 3: // url地址
          window.location.href = e.advUrl
          break
        case 4: // 分类
          this.$router.push(`/goods/list?name=${e.typevalue}`)
          break
        case 5: // 商品列表
          this.$router.push(`/goods/list?name=${e.typevalue}`)
          break
        case 6: // 售货机详情
          this.$router.push(`/machine/index?vemId=${e.typevalue}`)
          break
        case 7: // 积分商品
          this.$message.info('建设中')
          break
        case 8: // 优惠券领取
          this.$message.info('建设中')
          break
        case 9: // 客服电话
          window.location.href = 'tel://' + this.config.servicephone
          break
        case 10: // 无内容
          break
        case 11: // 售货机列表
          this.$router.push('/home/machine')
          break
        case 12: // 咖啡机列表
          this.$router.push('/home/coffee?type=2')
          break
      }
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style lang="scss">
.leftbar,
.leftbar2 {
  width: 140px;
  position: absolute;
  top: 41px;
  left: 0px;
  max-height: 466px;
  display: block;
  z-index: 998;
  color: #333;
  background: #fff;
  .item {
    line-height: 38px;
    &:hover {
      cursor: pointer;
      background: #ec9221;
      a {
        color: #fff;
      }
    }
  }
}
</style>